import { useDispatch } from "react-redux";
import { onChangePolicyCoveragePremiumDetails, setPolicyCoveragePremiumDetailsType } from "../../../../../features/ebam/plicy-data-page/policy-coverage-premium-details/policy-coverage-premium-details.slice";
import EditSaveCancelButtons from "../../../../ui/edit-save-cancel-buttons";
import Input from "../../../../ui/input";
import LabelHead from "../../../../ui/label-head";
import { customStyle, defaultStyle } from "../../../../../constant/custom-style";
import LefSideLabel from "../../../../ui/left-side-label";
import { useProposalTypeData } from "../../../../../hooks/proposal/use-proposal-type-data";
import PolicyContentHeaderAction from "./policy-content-header-action";
import { usePolicyActions } from "../../../../../hooks/actions/use-policy-actions";
import { usePolicyDataState } from "../../../../../hooks/policy/use-policy-data-state";

interface Props {
    isShow: boolean;
}

export default function PolicySchedulePremiums({ isShow }: Props) {

    const dispatch = useDispatch();
    const { handleEditScheduleOfInsurance, isLoadingUpdatePolicy, handleCancelEditPolicySchedule } = usePolicyActions()
    const { isGADDPolicy, isGCLIPolicy, modeOfPayment } = useProposalTypeData();
    const {
        isPCPDueDates,
        isPCPDueDatesInfo,
        policyDueDates,
        policyDueDatesInfo
    } = usePolicyDataState()
    const dispatchValue = isGCLIPolicy ? 'dueDates' : 'dueDatesInfo'

    if (!isShow) {
        return null;
    }

    return (
        <div className="border rounded text-xs">
            <div className='bg-[#eef6fc] border-b border-[#c7e0f3] px-3 py-2 text-left text-[#186cb2] sm:px-4 sm:py-2.5'>
                <div className="flex flex-row items-start justify-between gap-2 md:gap-4">
                    <PolicyContentHeaderAction
                        title='Premiums'
                        subTitle='Specify the payment schedule and due dates for the policy premiums.'
                    />
                    <EditSaveCancelButtons
                        isEditing={isGCLIPolicy ? !isPCPDueDates : !isPCPDueDatesInfo}
                        onEdit={() => dispatch(setPolicyCoveragePremiumDetailsType(dispatchValue))}
                        onCancel={handleCancelEditPolicySchedule}
                        onSave={() => handleEditScheduleOfInsurance(dispatchValue)}
                        isLoading={isLoadingUpdatePolicy}
                    />
                </div>
            </div>
            <div className="grid grid-cols-1 gap-4 sm:gap-5 md:grid-cols-2 px-3 py-2 sm:px-4">
                <div>
                    <LabelHead label="Mode of Payment"/>
                    <Input
                        type='text'
                        name='modeOfPayment'
                        value={modeOfPayment?.name ?? ''}
                        isCustomStyle={true}
                        customCss={`${defaultStyle} ${customStyle}`}
                        onChange={() => {}}
                        required={true}
                        placeholder='e.g., G-CLI-2026-0001'
                        disabled
                    />
                </div>
                <div>
                    <LabelHead label="Due Dates"/>
                    {isGCLIPolicy && (
                        <Input
                            type='text'
                            name='dueDates'
                            value={policyDueDates}
                            isCustomStyle={true}
                            customCss={`${defaultStyle} ${!policyDueDates ? "" : `${customStyle}`}`}
                            onChange={(e) => {
                                dispatch(onChangePolicyCoveragePremiumDetails({ field: 'dueDates', value: e.target.value}))
                            }}
                            required={true}
                            placeholder='e.g., January 1, 2026'
                            disabled={!isPCPDueDates || isLoadingUpdatePolicy}
                        />
                    )}
                    {isGADDPolicy && (
                        <div className="flex flex-col space-y-2">
                            <div className={`flex overflow-hidden rounded border focus-within:border-[#186cb2] ${policyDueDatesInfo.first_due_date ? "border-[#186cb2]" : "border-gray-300" }`} >
                                <LefSideLabel label="First"/>
                                <Input
                                    type="text"
                                    name={`dueDatesInfo-first`}
                                    value={policyDueDatesInfo.first_due_date}
                                    isCustomStyle={true}
                                    customCss={`w-full rounded-tr rounded-br px-2 py-1.5 text-xs outline-none ${!policyDueDatesInfo.first_due_date ? "" : "bg-[#186cb2]/10" }`}
                                    onChange={(e) => {
                                        dispatch(onChangePolicyCoveragePremiumDetails({ 
                                            field: 'dueDatesInfo', 
                                            value: { 
                                                ...policyDueDatesInfo, 
                                                first_due_date: e.target.value
                                        }}))
                                    }}
                                    required={true}
                                    disabled={!isPCPDueDatesInfo || isLoadingUpdatePolicy}
                                />
                            </div>
                            <div className={`flex overflow-hidden rounded border focus-within:border-[#186cb2] ${policyDueDatesInfo.renewal_due_date ? "border-[#186cb2]" : "border-gray-300" }`} >
                                <LefSideLabel label="Renewal"/>
                                <Input
                                    type="text"
                                    name={`dueDatesInfo-renew`}
                                    value={policyDueDatesInfo.renewal_due_date}
                                    isCustomStyle={true}
                                    customCss={`w-full rounded-tr rounded-br px-2 py-1.5 text-xs outline-none ${!policyDueDatesInfo.renewal_due_date ? "" : "bg-[#186cb2]/10" }`}
                                    onChange={(e) => {
                                        dispatch(onChangePolicyCoveragePremiumDetails({ 
                                            field: 'dueDatesInfo', 
                                            value: { 
                                                ...policyDueDatesInfo, 
                                                renewal_due_date: e.target.value
                                        }}))
                                    }}
                                    required={true}
                                    disabled={!isPCPDueDatesInfo || isLoadingUpdatePolicy}
                                />
                            </div>
                            <div className={`flex overflow-hidden rounded border focus-within:border-[#186cb2] ${policyDueDatesInfo.additions_due_date ? "border-[#186cb2]" : "border-gray-300" }`} >
                                <LefSideLabel label="Additions"/>
                                <Input
                                    type="text"
                                    name={`dueDatesInfo-add`}
                                    value={policyDueDatesInfo.additions_due_date}
                                    isCustomStyle={true}
                                    customCss={`w-full rounded-tr rounded-br px-2 py-1.5 text-xs outline-none ${!policyDueDatesInfo.additions_due_date ? "" : "bg-[#186cb2]/10" }`}
                                    onChange={(e) => {
                                        dispatch(onChangePolicyCoveragePremiumDetails({ 
                                            field: 'dueDatesInfo', 
                                            value: { 
                                                ...policyDueDatesInfo, 
                                                additions_due_date: e.target.value
                                        }}))
                                    }}
                                    required={true}
                                    disabled={!isPCPDueDatesInfo || isLoadingUpdatePolicy}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
